import classes from "./mapPOIS/MapPOIS.module.css";
import { Fragment } from "react";
import Title from "./../../UI/box/title/Title";

const Epop = () => {
  return (
    <Fragment>
      <Title
        className={classes.map_title_style}
        icon={"im im-icon-Eye-Visible"}
        title={"ΕΠΟΠΤΕΙΑ"}
        infoContext={
          "Συγκεντρωτική απεικόνιση του συνόλου των υποσυστημάτων που διαθέτει ο Δήμος."
        }
        link={`/frame?id=6`}
        element={
          <i
            id="draggable"
            className="im im-icon-Double-Tap"
            style={{
              fontSize: "32px",
              minWidth: "32px",
              color: "black",
              cursor: "pointer",
            }}
          />
        }
      />

    </Fragment>
  );
};

export default Epop;
